import { CommonProp, CompactHeader, FirstTier, generate, PageContentLayout, PageWrapper } from '@acin/ui-core';
import React from 'react';
import { PageLayout } from '../../../components/PageLayout';
import { RegulationsOverview } from '../../../components/RegulationsOverview';
import * as SC from './Homepage.styled';

export interface HomepageProps extends CommonProp {
  className?: string;
}

export const Homepage: React.FC<HomepageProps> = (props) => {
  const { className } = props;

  return (
    <SC.Homepage data-testid={generate(['reg-mapping-homepage'], props)} className={className}>
      <PageLayout>
        <PageWrapper header={<CompactHeader firstTier={<FirstTier title="All Regulations" variation="parent" />} />}>
          <PageContentLayout headerHeight={116}>
            <RegulationsOverview />
          </PageContentLayout>
        </PageWrapper>
      </PageLayout>
    </SC.Homepage>
  );
};
